import { useAjaxCall } from '~/_shared/utils/hooks/useAjaxCall';
import { recordTemplateUsage } from './mapTemplates.repository';

export const useRecordTemplateUsage = () => {
  const { invokeAjax, isLoading } = useAjaxCall(recordTemplateUsage);

  return {
    create: invokeAjax,
    isLoading,
  };
};
